module.exports = "/fonts/nucleo-icons.ttf?d6a66724e7a7bf1bba65051b309df222";